import { RolodexSyncType, useRolodexSync } from 'features/fde/rolodexAPI'
import {
  entryToIndication,
  IndicationItem,
  indicationToEntry,
  RD_TYPE_INDICATION,
  RolodexIndication,
} from 'features/indicationTriage'
import { RolodexEntryQueryBody } from 'features/rolodex'
import { useCallback, useMemo } from 'react'
import { GeckoComponent, GeckoInspection, RolodexEntryType } from 'types'

export function useRolodexSyncIndications(
  tags: RolodexEntryQueryBody['tags'] | undefined,
  selectedComponent: GeckoComponent | undefined,
  selectedInspection: GeckoInspection | undefined
): RolodexSyncType<IndicationItem> {
  const roiQuery = useMemo(
    () => ({
      type: RD_TYPE_INDICATION,
      tags,
    }),
    [tags]
  )

  const rdSync = useRolodexSync<RolodexIndication>(
    roiQuery,
    indicationToEntry,
    entryToIndication
  )
  const { tags: componentTags } = selectedComponent ?? { tags: {} }
  const setValues = useCallback(
    (vals: ReadonlyArray<IndicationItem>) => {
      rdSync.setValues(
        vals.map((val) => {
          const tags = {
            ...componentTags,
            component: val.componentId ?? null,
            inspection: selectedInspection?.id ?? null,
          }
          return {
            ...val,
            tags: {
              ...Object.fromEntries(
                Object.entries(tags).filter(([, value]) => value !== null)
              ),
              [RolodexEntryType.INDICATION_SET]: val.indicationSetId,
            },
          }
        })
      )
    },
    [componentTags, rdSync, selectedInspection?.id]
  )
  return useMemo(() => {
    return {
      values: rdSync.values,
      setValues,
      isLoading: rdSync.isLoading,
      forceRefresh: rdSync.forceRefresh,
    }
  }, [rdSync.forceRefresh, rdSync.isLoading, rdSync.values, setValues])
}
